export default {
    login: {
        first: 'Wij creëren',
        second: 'sensoroplossingen voor u.',
        third: 'Ons eenvoudige maar intelligente ontwerp biedt u de tools om real-time gegevens om te zetten in onmiddellijk verbeterde bedrijfsprestaties.',
        first_flower: 'wij brengen kleur aan in de openbare ruimte met onze duurzame plantconcepten',
        second_flower: '',
        third_flower: 'We brengen kleur aan in de openbare ruimte met onze duurzame concepten. Dit doen wij door het leveren en planten van bloembollen, wilde bloemen en vaste planten.',
        desc: 'Log in door onderstaande hieronder informatie',
        username: 'Email',
        password: 'Paswoord',
        successful: 'Succesvol ingelogd',
        logout: 'Uitloggen',
        log: 'Log',
        in: 'in',
    },
    dashboard: {
        search: 'Zoeken',
        no_lora_id: 'Geen LoRa-ID',
        dealer_view: 'Dealer view',
        nav: {
            remark: 'Opmerking',
            batch: 'Kalibratie',
            location: 'Locatie',
            lqi: 'Verbindingslink',
            lqi_hover: 'Link Quality Indicator',
            unit: 'Eenheid',
            last_event: 'laatste evenement',
            l_update: 'Laatste gegevens',
            timing: 'Dynamische timing',
            sensing: 'Geavanceerde instellingen',
            notification: 'Notificaties',
            customer: 'Klant',
            favourite: 'Favoriete',
        },
        bulk_setup: {
            substrate_properties: 'Ondergrond eigenschappen',
            frame_selection: 'Frame selectie',
            critical_value: 'Meldingsdrempels',
            payload_error: 'Payload-indeling van geselecteerde apparaten is niet identiek',
            hundred_tx_power: 'Berekend voor 100% zendvermogen.',
            version_error: 'Levensduurberekening alleen beschikbaar voor apparaten met identieke uitvoeringen.',
            sa_error: 'Levensduurberekening is alleen beschikbaar voor apparaten zonder zelfbewustzijn (kijk op de apparaatdetailpagina).',
            sa_version_error: 'Levensduurberekening is alleen beschikbaar voor apparaten met identieke versies zonder zelfbewustzijn (zie de apparaatdetailpagina voor informatie over de levensduur van het apparaat).',
            version_identical_sa_error: 'La selección de perfil solo está disponible para dispositivos con la misma versión.',
            batch_type_error: 'Type tentakelkalibratie is niet identiek (eigenschappen uitgeschakeld)',
            batch_missing_error: 'Een of meer tentakelkalibratie is niet ingesteld (eigenschappen uitgeschakeld)',
            batch_all_error: 'Stel alle eigenschappen in om door te gaan',
            affected: 'Wijziging toegepast op {count} apparaten',
            identical_version_error: 'Selecteer apparaten met identieke versies voor bulkbewerking (wijziging van meetinterval niet mogelijk).',
            measurement_interval_cant: 'Wijziging meetinterval niet beschikbaar.',
            measurement_sets_cant: 'Wijziging accumulatie, downlinkinterval en downlink-pogingen zijn niet beschikbaar.',
            sa_active_error: 'Selecteer apparaten zonder actief Zelfbewustzijnsprofiel om \'Accumulatie\', \'Downlink-interval\' en \'Downlink-pogingen\' te wijzigen',
            sa_mixed_error: 'Selecteer alleen apparaten met of zonder actief Self Awareness-profiel om de frameselectie te bewerken (combinatie niet mogelijk).',
            expert_mode: '*Expertmodus ingeschakeld!! Alle opties worden weergegeven terwijl Zelfbewustzijn is ingeschakeld.',
            data_auto_scaling: '*Automatische Gegevensschaal ingeschakeld! Sensor gebruikt kalibratiecoëfficiënten van de schaal. ',
        },
        remark: {
            double_click: 'Dubbelklik',
            to_add: 'om waarde toe te voegen',
            history: 'Opmerking Geschiedenis',
            show_history: 'Geschiedenis van opmerkingen weergeven',
        },
    },
    map: {
        calculated: 'Berekende locatie',
        manual: 'Handmatige plaatsing',
    },
    detail: {
        new_calib_point: 'Voeg een nieuw kalibratiepunt toe',
        remove_calib_point: 'Verwijder het kalibratiepunt',
        raw_value: 'Ruwe waarde',
        calibrate_min: 'Kalibreer min.',
        calibrate_max: 'Kalibreer max.',
        apply_calib: 'Pas kalibratie toe op eigenschappen',
        reset_minmax: 'Reset min en max waarden',
        reset_calib: 'Reset naar toegewezen kalibratie',
        select_props: 'Selecteer eigenschappen om te kalibreren',
        save_props: 'Opslaan in geselecteerde eigenschappen',
        percent: 'VWC',
        batch: 'Kalibratie',
        selected_batch: 'Geselecteerde kalibratie',
        raw: 'Raw',
        warning: 'Waarschuwing',
        warning_vwc: 'De waarde voor VWC of het RAW-equivalent is ongeldig. Corrigeer de waarden om meer dan minimum, minder dan maximum of een andere niet bestaande waarde te zijn.',
        measured_min: 'Gemeten minimum',
        measured_max: 'Gemeten maximum',
        select_props: 'Selecteer eigenschappen',
        lqi: 'Link kwaliteit',
        lqi_calculated: 'Berekend met basisstations.',
        map: 'Sensor locatie',
        sensor_setting: 'Sensor instellingen',
        etentacles_setting: 'iTentacles-instellingen',
        min_value: 'Minimale waarde',
        last_value: 'Laatste waarde',
        max_value: 'Maximale waarde',
        select_data: 'Selecteer data',
        missing: 'Geen gegevens beschikbaar',
        moisture_calibration: 'VWC-kalibratie',
        warning_batch_calibration: 'Waarschuwing! U werkt de toegewezen kalibratie bij!',
        warning_device_calibration2: 'Waarschuwing! Om kalibratie toe te passen op eigenschappen - klik op "Pas kalibratie toe op eigenschappen"',
        device_only_label: 'Kalibreer alleen voor apparaat',
        payload_format: 'Meting frame (apparaat)',
        payload_format_change: 'Change measurement frame',
        payload_format_not_set: 'Not updated yet',
        payload_format_changed: 'Last change',
        payload_format_updated: 'Last Updated',
        format: 'Frame',
        set_format: 'Frame instellen',

        dynamic_sensing: 'Geavanceerde instellingen',
        measurement_frame: 'Meting frame',
        none: 'Geen',
        moisture: 'Vochtigheid',
        temperature: 'Temperatuur',
        light: 'Licht',
        measurement_sets: 'Geaccumuleerde meetsets',
        measurement_interval: 'Meetinterval',
        sigfox_frames_transmitted: 'Sigfox-frames verzonden',
        lora_connections: 'Lora-verbinding/netwerk',
        downlik_period: 'Downlink-periode',
        downlink_retries: 'Nieuwe pogingen tot downlink',
        transmitting_power: 'Zendvermogen',
        message_interval: 'Berichtinterval',
        sigfox_device_lifespan: 'SigFox-apparaat levensduur',
        device_lifespan: 'Apparaat levensduur',
        device_loralifespan: 'LoRa apparaat levensduur',
        downlink_max: 'Max efficiency',
        once_per_four: 'Een keer per 4 dagen',
        once_per_two: 'Een keer per 2 dagen',
        once_per_day: 'Een keer per dag',
        twice_per_day: 'Tweemaal per dag',
        set_dynamic_sensing: 'Geavanceerde instellingen instellen',
        sa_title: 'Zelfbewustzijn',
        sa_select_profile: 'Actief profiel',
        sa_enable_profile: 'Profiel instellen',
        sa_hover: 'Op basis van het profiel worden de apparaatinstellingen gewijzigd op basis van de communicatie-/verbindingsstatus',
        sa_automatic_mode: '*Opties beheerd door zelfbewustzijn zijn verborgen',
    },
    lqi: {
        Excellent: 'Uitstekend',
        Good: 'Mooi zo',
        Average: 'Gemiddelde',
        Limit: 'Beperkt'
    },
    privacy: {
        title: 'Privacybeleid',
    },
    sigfox_coverage: {
        title: 'Signaaldekking',
        coverage_error: 'Coverage Service Error',
        unstable: 'Er is geen dekking en het apparaat synchroniseert mogelijk niet.',
        works_underground: 'De link is sterk en het apparaat moet ondergronds of diep binnenshuis werken.',
        possible_underground: 'De schakel is sterk genoeg om ondergronds of diep binnenshuis te kunnen werken.',
        works_indoor: 'De verbinding is stabiel en het apparaat zou binnenshuis moeten werken (werkt mogelijk niet ondergronds).',
        possible_indoor: 'De schakel is stabiel genoeg om binnenshuis te kunnen werken. (werkt mogelijk niet ondergronds).',
        works_open: 'De link is mogelijk niet stabiel en het apparaat zou in een open veld moeten werken.',
        possible_open: 'Het apparaat heeft een link gekregen en er is een mogelijkheid dat het apparaat op een open veld zou moeten werken.',
        coverage_env: "Apparaatplaatsing",
        coverage_env_greenhouse: "Kas",
        coverage_env_indoors: "Binnen",
        coverage_env_outdoors: "Buiten",
    },
    payload: {
        title: 'Soil 3XS nuttige lading',
    },
    export: {
        info: {
            first: 'Exporteer',
            second: 'gekozen',
            rest: 'Selecteer eerst enkele eenheden uit de tabel',
        },
        tabs: {
            date_range: 'Datumbereik',
            limit_values: 'Grenswaarden',
        },
    },
    contact_us: {
        title: 'Neem contact op',
        subj: 'Onderwerp',
        mess: 'Bericht',
    },
    tooltips: {
        customer: 'Toont apparaten die aan deze klant zijn toegewezen.',
        logout: 'Uitloggen',
        total_units: 'Totaal aantal eenheden',
        unit_name: 'Naam eenheid',
        excel: 'Exporteer Excel',
        csv: 'Exporteer CSV',
        search: 'of druk op',
        tentacle_missing: 'kies ten minste één tentacle',
        network: 'wijzig de weergegeven externe netwerk-ID',
    },
    buttons: {
        ok: 'Ok',
        login: 'Log in',
        detail: 'Detail',
        apply: 'Toepassen',
        apply_range: 'Bereik toepassen',
        bulk: 'Groepsinstellingen',
        bulkdetail: 'Groepsdetail',
        cancel: 'Annuleer',
        send: 'Sturen',
        export: 'Exporteer',
        delete_range: 'Verwijder meetwaardes',
        next: 'Volgende',
        previous: 'Vorige',
        save: 'Opslaan',
    },
    metrics: {
        moisture: 'VWC',
        moisture_top: 'Hogere VWC',
        moisture_middle: 'Middelgrote VWC',
        moisture_bottom: 'Lagere VWC',
        light: 'Licht',
        temperature: 'Temperatuur',
        battery: 'Batterij',
        pressure: 'Pressie',
        pump_mode: 'Pomp draait',
        gyroscope: 'Trillingen',
        events: 'Evenementen',
        currents: 'Fasestroom',
        angles: 'Fase hoek',
        over_vibration_stop: 'Over-vibratie stop',
    },
    timing: {
        t1: '15 minuten',
        t2: '30 minuten',
        t3: '1 uur',
        t4: '2 uur',
        t5: '8 uur',
        t6: 'Schakel uit',
    },
    interval: {
        day: 'dag',
        week: 'voor een week',
        month: 'voor maand',
        year: 'voor jaar',
    },
    notifications: {
        push: 'Notificaties',
    },
    sensing: {
        sens1: 'Huidige Soil 3XT-4',
        sens2: 'Original 2x per uur',
        sens3: 'Vochtigheid 4x per uur',
        sens4: 'Vochtigheid 3x per 45 min',
        sens5: 'Vochtigheid/Temp 2x per 30 min',
        sens6: 'Vochtigheid/Temp/Licht 2x per 30 min',
    },
    info: {
        loading_data: 'Data laden'
    },
    eventChart: {
        networkGatewaysCreated: 'Voorziening naar netwerk',
        networkGatewayActive: 'Apparaat AAN',
        networkGatewayRemoved: 'Verwijderen uit netwerk',
        fportSettingsChange: 'Geavanceerde LoRa-instellingen wijzigen',
        activeGatewayChange: 'Netwerk gewijzigd',
        networkChangeRequest: 'Netwerk wijzigen',
        networkDownlinkLimit: 'Downlink limiet',
        fportSettingsChange101Message: 'Apparaat geaggregeerde instellingen bijgewerkt',
        fportSettingsChange102Message: 'Apparaat LoRa-gegevensoverdrachtsnelheden bijgewerkt',
        fportSettingsChange103Message: 'Apparaat hertransmissie-instellingen bijgewerkt',
        activeGatewayChangeMessage: 'Netwerk van apparaat {previous} gewijzigd naar {active}',
        networkChangeRequestMessage: 'Netwerk van apparaat {previous} gewijzigd naar {new}',
        networkDownlinkLimitMessage: 'Het limiet voor LoRa-downlinks is bereikt. De volgende beschikbare downlink (instellingen) is morgen.',
        networkGatewaysCreatedMessage: 'Apparaat is toegewezen aan netwerken [{networks}]',
        networkGatewayActiveMessage: 'Het apparaat heeft de eerste gegevens verzonden op het {network}-netwerk',
        networkGatewayRemovedMessage: 'Apparaat is verwijderd uit netwerk {network}',
        sequenceMessage: 'Het verwachte volgnummer was {previous} kwam {actual}',
        ensBackupMessage: 'ENS heeft het netwerk veranderd naar {network} vanwege netwerk onbeschikbaarheid.',
        ensSequenceMessage: 'ENS heeft het netwerk veranderd naar {network} vanwege een ontbrekend bericht.',
        ansRegularMessage: 'ANS heeft het netwerk veranderd naar {network} vanwege een slechte netwerkverbinding.',
        ansExecutionMessage: 'ANS/ENS heeft het {network} netwerk geselecteerd.',
        lqiMessage: 'Lqi is laag voor eerdere {badCount}-berichten. De laatste was "{lqi}"',
        invalidMessage: 'Apparaat verzendt onjuiste gegevens',
        ackMessage: 'De verwachte update van het apparaat was {expectedAt}',
        sequence: 'Ontbrekend volgnummer',
        lqi: 'Lage LQI',
        power: 'Zendvermogen veranderen:',
        settings: 'Instellingen gewijzigd',
        invalid: 'Onjuiste data',
        pendingChange: 'Wijziging in afwachting',
        pendingChangeMessage: 'Apparaat moet gewijzigde instellingen nog toepassen.',
        verifiedChange: 'Geverifieerde wijziging',
        verifiedChangeMessage: 'Apparaat geverifieerde instellingen gewijzigd door downlink.',
        ack: 'Instellingen niet toegepast',
        info: 'Info',
        warning: 'Waarschuwing',
        error: 'Fout',
        latestEvent: 'laatste evenement',
        sigfoxDeleted: 'Cloud UIT-status',
        sigfoxCreated: 'Cloud AAN-status',
        deviceOn: 'Apparaat AAN',
        sigfoxDeletedMessage: 'Cloud-apparaat is ingesteld op UIT-status',
        sigfoxCreatedMessage: 'Cloud-apparaat is ingesteld op AAN-status',
        deviceOnMessage: 'Het apparaat heeft de eerste gegevens verzonden via het SigFox-netwerk',
        events: 'Evenementen',
        message: 'Bericht',
        default: 'Standaard',
        changedBy: 'Gewijzigd door {name}',
        customer: 'Verandering van de klant',
        calibration: 'Kalibratie gewijzigd',
        calibrationMessage: 'Kalibratie-instellingen veranderen.',
        customerMessage: 'Klant is gewijzigd in {name}.',
        baseCalibrationMessage: 'De basiskalibratie is gewijzigd in "{calibration}".',
        propertiesCalibrationMessage: 'De kalibratie is gewijzigd in "{properties}"".',
        powerMessage: 'De uitzendinstellingen van het apparaat zijn gewijzigd.',
        transmittingMessage: 'Zendvermogen gewijzigd van {previous} naar {actual}.',
        periodMessage: 'Periode gewijzigd van "{previous}" in "{actual}".',
        networkTypesMessage: 'Netwerktype gewijzigd van "{previous}" in "{actual}".',
        sfFramesMessage: 'Sigfox verzendende frames gewijzigd van "{previous}" naar "{actual}".',
        spanMessage: 'De meetintervalspanne is gewijzigd van {previous} naar {actual} minuten.',
        retriesMessage: 'Aantal nieuwe pogingen gewijzigd van {previous} in {actual}.',
        settingsMessage: 'Apparaatinstellingen gewijzigd.',
        frameMessage: 'Het frame is gewijzigd van "{previous}" in "{actual}".',
        intervalMessage: 'Het interval is gewijzigd van {previous} in {actual} minuten.',
        accumulationMessage: 'De accumulatie is gewijzigd van {previous} naar {actual} berichten.',
        thresholdMessage: 'Apparaat heeft kritische waarden gemeten.',
        criticalMessage: '{sensor} sensor kritieke waarde van {value}{unit} bereikt (drempel ingesteld {threshold}{unit}).',
        threshold: 'Kritische waarde',
        attentionMessage: 'Apparaat gemeten attentiewaarden.',
        notificationMessage: '{sensor} sensoraandachtswaarde van {value}{unit} bereikt (drempelwaarde ingesteld op {threshold}{unit}).',
        attention: 'Attentiewaarde',
        selfAwarenessChange: 'Zelfbewustzijn',
        selfAwarenessChangeTooltipSequence: 'Instellingen voor zelfbewustzijn toegepast.',
        selfAwarenessChangeTooltipLqi: 'Instellingen voor zelfbewustzijn toegepast.',
        selfAwarenessChangeTooltipStandby: 'Instellingen voor zelfbewustzijn genegeerd.',
        selfAwarenessChangeTooltipVwc: 'Instellingen voor zelfbewustzijn genegeerd.',
        selfAwarenessChangeMessageSequence: 'Er is een ontbrekend bericht gedetecteerd en de instellingen voor zelfbewustzijn uitgevoerd voor het profiel {state} {profile}.',
        selfAwarenessChangeMessageLqi: 'Matched {number} {lqi} LQI en voerde zelfbewustzijn uit op {state} {profile} profiel.',
        selfAwarenessChangeMessageStandby: 'Uitvoering van zelfbewustzijn wordt overgeslagen omdat het apparaat in de stand-bymodus staat.',
        selfAwarenessChangeMessageVwc: 'Uitvoering van zelfbewustzijn werd overgeslagen omdat het apparaat een VWC van minder dan 5% meet.'
    },
    transmittingPower: {
        15: "125%",
        14: "100%",
        13: "80%",
        12: "65%",
        11: "50%",
        10: "40%",
        9: "33%",
        8: "25%",
        7: "20%"
    },
    downlinkPeriods: {
        0: {
            25: "Een keer per 4 dagen",
            5: "Een keer per 2 dagen"
        },
        1: "Een keer per dag",
        2: "Tweemaal per dag"
    },
    networkTypes: {
        1: "Alleen Sigfox",
        2: "Alleen LoRa",
        3: "Prioriteit laatst verbonden",
        4: "Prioriteit SigFox",
        5: "Prioriteit LoRa"
    },
    sfFrames: {
        1: "Eén kader",
        2: "Drie kaders"
    },
    sensors: {
        Moist: 'VWC',
        light: 'Licht',
        temp: 'Temperatuur',
        battery: 'Batterij'
    },
    slider: {
        header: {
            attention: 'Aandacht',
            critical: 'Kritiek',
        }
    },
    header: {
        custom_name: "Aangepaste naam",
        generic_name: "Algemene naam",
        network_sigfox: "Sigfox",
        network_lora: "LoRa",
    },
    network: {
        active_network: 'Actief netwerk',
        null: 'Onbekend',
        sigfox: 'Sigfox',
        helium: 'Helium',
        skynet: 'SkyNet',
    }
};
